module.exports = __webpack_public_path__ + "img/network.84e2cca3.svg";